import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../utils/supabase";

function ProfileMenu({ user }) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setIsOpen(false);
    navigate("/");
  };

  // Get the first letter of the name for the avatar
  const displayName = user?.user_metadata?.full_name || user?.email || "User";
  const initial = displayName.charAt(0).toUpperCase();

  return (
    <div ref={menuRef} className="relative">
      {/* Avatar Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-8 h-8 flex items-center justify-center text-[12px] transition-all duration-200"
        style={{
          backgroundColor: "#FF6B00",
          color: "#000",
          fontWeight: 700,
        }}
      >
        {initial}
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div
          className="absolute right-0 top-12 w-[240px] border border-[#222] py-2 z-[300]"
          style={{
            backgroundColor: "#111",
            animation: "fadeUp 0.2s ease-out",
          }}
        >
          {/* User Info */}
          <div className="px-4 py-3 border-b border-[#222]">
            <p
              className="text-text-primary text-[13px]"
              style={{ fontWeight: 600 }}
            >
              {displayName}
            </p>
            <p className="text-[#888] text-[11px] mt-1">{user?.email}</p>
          </div>

          {/* Menu items */}
          <button
            onClick={() => {
              navigate("/account");
              setIsOpen(false);
            }}
            className="w-full text-left px-4 py-2 text-[12px] text-[#b0b0b0] hover:text-text-primary hover:bg-[#1a1a1a] transition-colors"
            style={{ fontWeight: 500 }}
          >
            Account
          </button>

          {/* Divider */}
          <div className="border-t border-[#222] my-1"></div>

          {/* Logout Button */}
          <button
            onClick={handleLogout}
            className="w-full text-left px-4 py-2 text-[12px] text-[#888] hover:text-[#f87171] hover:bg-[#1a1a1a] transition-colors"
            style={{ fontWeight: 500 }}
          >
            Log Out
          </button>
        </div>
      )}
    </div>
  );
}

export default ProfileMenu;
